// Project tasks list
import {List, Map} from "immutable";

export const projectTasks = new List([
    new Map({
        task_code: -1,
        name: 'Selecciona una tarea'
    }),
    new Map({
        task_code: '0',
        name: 'Recepción de material'
    }),
    new Map({
        task_code: '1',
        name: 'Preparación proyecto'
    }),
    new Map({
        task_code: '2',
        name: 'Corte y/o transformación'
    }),
    new Map({
        task_code: '3',
        name: 'Ensamblaje'
    }),
    new Map({
        task_code: '4',
        name: 'Soldadura'
    }),
    new Map({
        task_code: '5',
        name: 'Limpieza'
    }),
    new Map({
        task_code: '6',
        name: 'Acabado superficial'
    }),
    new Map({
        task_code: '7',
        name: 'Pruebas'
    }),
    new Map({
        task_code: '8',
        name: 'Embalaje'
    }),
    new Map({
        task_code: '9',
        name: 'Reparaciones por garantía'
    }),
    new Map({
        task_code: '10',
        name: 'Reforma por mala ejecución'
    })
]);



// WEBPACK FOOTER //
// ./src/components/common/project-tasks.js